<template>
    <v-footer class="py-3 mt-8" dark color="primary" padless></v-footer>
</template>

<script>
export default {
  name: 'FooterToolbar',
  components: {
  }
}
</script>
